import { c as _c } from "react/compiler-runtime";
import { createContext, Dispatch, PropsWithChildren, useState } from 'react';
import HookdeckAPI from '../../client/Hookdeck';
interface Configs {
  API_URL: string;
  OUTPOST_API_URL?: string;
  APP_URL: string;
  SENTRY_DSN: string;
  ROOT_DOMAIN: string;
  WEBSITE_URL: string;
  ENV: string;
  LONG_TIMEOUT_ATTEMPT_ROUTING_ENABLED: boolean;
}
type Props = {
  children: React.ReactNode;
  configs: Configs;
};
export type GlobalContext = {
  HookdeckAPI: HookdeckAPI;
  setAPITeamId: Dispatch<string | null>;
  configs: Configs;
};
export const GlobalContext = createContext<GlobalContext>({
  HookdeckAPI: {} as HookdeckAPI,
  setAPITeamId: () => null,
  configs: {} as Configs
});
export const GlobalContextProvider: React.FC<PropsWithChildren<Props>> = t0 => {
  const $ = _c(10);
  const {
    configs,
    children
  } = t0;
  const [api_team_id, setAPITeamId] = useState(null);
  const t1 = api_team_id || "";
  let t2;
  if ($[0] !== configs.API_URL || $[1] !== configs.OUTPOST_API_URL || $[2] !== t1) {
    t2 = new HookdeckAPI(configs.API_URL, t1, configs.OUTPOST_API_URL);
    $[0] = configs.API_URL;
    $[1] = configs.OUTPOST_API_URL;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hookdeckAPI = t2;
  let t3;
  if ($[4] !== configs || $[5] !== hookdeckAPI) {
    t3 = {
      HookdeckAPI: hookdeckAPI,
      setAPITeamId,
      configs
    };
    $[4] = configs;
    $[5] = hookdeckAPI;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const context = t3;
  let t4;
  if ($[7] !== children || $[8] !== context) {
    t4 = <GlobalContext.Provider value={context}>{children}</GlobalContext.Provider>;
    $[7] = children;
    $[8] = context;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};